import React from 'react';
import { Trans } from 'react-i18next';
import { ToastContainer, Content, Header, Message } from '@components/Toast/Toast.styles';

export const Toast = ({ isVisible, variant = 'info', header, i18nKey, components = [] }) => {
  if (!isVisible) return null;
  return (
    <ToastContainer variant={variant}>
      <Content>
        {header && <Header>{header}</Header>}
        <Message>
          <Trans i18nKey={i18nKey} components={components} />
        </Message>
      </Content>
    </ToastContainer>
  );
};
